export default __webpack_public_path__ + "static/media/Seated_beauty_II_Van_Haal_30_x_40.3f354e9d.jpg";